import delegate from "delegate-it";
import { setupForms } from "@/scripts/components/form/form";
import {
  setupMultistepForm,
  setupHistoryListener,
  setupStepLinkListener,
} from "@/scripts/components/form/multistep-form";

const handleLoadStep = () => {
  setupForms();

  document.querySelectorAll(".multistep-form").forEach((form) => {
    setupMultistepForm(form);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector(".multistep-form-page")) {
    return;
  }

  document.querySelectorAll(".multistep-form").forEach((form) => {
    setupMultistepForm(form);
  });

  setupHistoryListener();
  setupStepLinkListener();

  delegate("html", "multistep-form:load", handleLoadStep);
});
